import React from 'react';
import styles from '../styles/components/SurveyNameHeaderEditable.module.css';
import {
  useSurveyContext,
  useSurveyDispatchContext,
} from 'contexts/SurveyContext';
import editIcon from '../assets/pencil_gray.svg';
import { getPanelTypeText } from '@ax2/common/model/PanelType';
import { EditText } from './EditText';

interface SurveyNameHeaderEditableData {
  isEditable: boolean;
}

export const SurveyNameHeaderEditable: React.FC<
  SurveyNameHeaderEditableData
> = ({ isEditable }) => {
  const surveySchema = useSurveyContext();
  const surveyDispach = useSurveyDispatchContext();
  return (
    <div className={styles.surveyNameHeaderWrapper}>
      <div className={styles.surveyNameHeaderContainer}>
        {surveySchema && surveySchema.sourceTitle ? (
          <div className={styles.infoContainer}>
            <span
              className={styles.infoBoldText}
            >{`From ${surveySchema.sourceTitle}`}</span>
          </div>
        ) : (
          <div className={styles.infoContainer}>
            <span className={styles.infoBoldText}>{`Custom survey`}</span>
          </div>
        )}
        <div className={styles.surveyNameWrapper}>
          {isEditable && (
            <div className={styles.editIconContainer}>
              <img src={editIcon} alt="edit" />
            </div>
          )}
          <div className={styles.surveyNameContainer}>
            {isEditable && (
              <EditText
                placeholder={'Name Your Survey Here'}
                value={
                  surveySchema && surveySchema.title ? surveySchema.title : ''
                }
                onChange={v => {
                  surveyDispach({ type: 'title', title: v });
                }}
              />
            )}
            {isEditable === false && (
              <span className={styles.surveyName}>
                {surveySchema && surveySchema.title
                  ? surveySchema.title
                  : 'Unspecified'}
              </span>
            )}
            {surveySchema && surveySchema.panel && (
              <span className={styles.panelNameText}>{`For ${getPanelTypeText(
                surveySchema.panel
              )} Panel`}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
